import styled, { css } from "styled-components";

export const CoursesContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;

  @media (min-width: 990px) {
    margin-top: 4rem;
  }

  .loader {
    position: absolute;
    top: 50vh;
  }

  .ant-empty-description {
    font-size: 18px;
  }

  .title-section {
    margin: 2rem 0 0 0;
    font-size: 22px;

    h1 {
      font-weight: 700;
      margin-bottom: 1rem;
    }
  }

  .title-section,
  .inputs-container {
    margin-left: 4rem;
  }

  ${({ theme }) =>
    theme.mode === "dark" &&
    css`
      .title-section h2,
      .inputs-container p,
      button.ant-btn.ant-input-search-button.ant-btn-primary {
        color: #ffffff !important;
      }

      .ant-btn,
      .ant-btn-primary,
      .ant-btn-primary:hover {
        color: ${({ theme }) => theme.colors?.btnTextColor} !important;
      }

      .ant-select {
        .ant-select-selector {
          background-color: #282828 !important;
          border-color: #282828 !important;
          color: #ffffff;
        }

        .ant-select-arrow {
          color: white;
        }

        .ant-select-clear {
          background: transparent;
        }
      }

      .title {
        color: #ffffff;
      }
    `}

  .max-width-definer {
    width: 100%;
    max-width: 1920px;

    display: flex;
    flex-direction: column;

    margin-bottom: 400px;

    div.ant-spin {
      margin: 50px 0 20px 0;
    }
  }

  @media (max-width: 900px) {
    .title-section,
    .inputs-container {
      margin-left: 7.5px;
    }

    .max-width-definer {
      padding: 0 30px;
    }
  }
`;
